<div class="ps-row" [formGroup]="projectItemForm">
  <mat-form-field appearance="fill" class="ps-name">
    <mat-label><span class="mandatory">* </span>Status name</mat-label>
    <input matInput formControlName="statusName" type="text" maxlength="100">
    <mat-error *ngIf="displayMessage.statusName">{{ displayMessage.statusName }}</mat-error>
  </mat-form-field>

  <mat-form-field appearance="fill" class="ps-group">
    <mat-label>Group</mat-label>
    <mat-select formControlName="statusGroup" panelClass="project-status-select-panel">
      <mat-option *ngFor="let status of statusOptions" [value]="status">{{ status }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill" class="ps-order">
    <mat-label>Order</mat-label>
    <input matInput formControlName="sortOrder" type="text" maxlength="2">
    <mat-error *ngIf="displayMessage.sortOrder">{{ displayMessage.sortOrder }}</mat-error>
  </mat-form-field>

  <div class="ps-actions" *ngIf="!readOnly">
    <button mat-icon-button *ngIf="count > 1" (click)="removeProjectItem(current)"
      matTooltip="remove status" matTooltipPosition="above">
      <mat-icon>remove</mat-icon>
    </button>
    <button mat-icon-button *ngIf="current + 1 == count" (click)="addProjectItem()"
      matTooltip="add status" matTooltipPosition="above">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
